document.addEventListener("DOMContentLoaded", function () {
  const dropdownSelectors = [
    'a[aria-controls="header-menu-dropdown-1"]',
    'a[aria-controls="header-menu-dropdown-2"]',
    'a[aria-controls="header-menu-dropdown-3"]',
    'button[aria-controls="menu-drawer"]'
  ];

  let saveIcon = null;

  function updateSaveIconClass() {
    const isExpanded = dropdownSelectors.some(selector => {
      const el = document.querySelector(selector);
      return el && el.getAttribute("aria-expanded") === "true";
    });

    if (saveIcon) {
      saveIcon.classList.toggle("custom_invert", isExpanded);
    }
  }

  function initObservers() {
    dropdownSelectors.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) {
        const observer = new MutationObserver(updateSaveIconClass);
        observer.observe(element, {
          attributes: true,
          attributeFilter: ["aria-expanded"]
        });
      }
    });

    updateSaveIconClass(); // inizializza stato corrente
  }

  // Aspetta che TUTTI gli elementi siano nel DOM
  const waitForAllElements = setInterval(() => {
    const dropdownsExist = dropdownSelectors.every(sel => document.querySelector(sel));
    saveIcon = document.querySelector("x-header .saveICON");

    if (dropdownsExist && saveIcon) {
      clearInterval(waitForAllElements);
      initObservers();
    }
  }, 100); // controlla ogni 100ms
});
